import React from 'react'
import { LoopVideo } from './LoopVideo'

type Props = {
  title: string
  /** Short line above the title, like a date */
  kicker?: string
  description?: string
  /** path relative to src/assets */
  image?: string
  /** path relative to src/assets. Plays behind the title instead of the image */
  video?: string
  /** Where the media is anchored when it gets cropped, as a CSS object-position */
  position?: string
  /** Class and event pages get a taller banner than information pages */
  size?: 'short' | 'tall'
  children?: React.ReactNode
}

/** A photo banner with the page title over it */
export const PageHeading = ({
  title,
  kicker,
  description,
  image = 'stlswing/wednesday-night-swing.jpg',
  video,
  position = 'center',
  size = 'short',
  children,
}: Props) => {
  const media = 'absolute inset-0 object-cover w-full h-full'
  const height =
    size === 'tall'
      ? 'min-h-[22rem] md:min-h-[28rem] lg:min-h-[32rem]'
      : 'min-h-[15rem] md:min-h-[19rem]'

  return (
    <header className='relative overflow-hidden text-white bg-ink'>
      {video ? (
        <LoopVideo
          src={require(`../../assets/${video}`)}
          style={{ objectPosition: position }}
          className={media}
        />
      ) : (
        <img
          src={require(`../../assets/${image}`)}
          alt=''
          style={{ objectPosition: position }}
          className={media}
        />
      )}
      {/* Darkens only where the text sits, so the photo keeps its own colour */}
      <div className='absolute inset-0 bg-gradient-to-t from-ink via-ink/60 to-ink/10' />

      <div
        className={`relative flex flex-col justify-end max-w-6xl px-4 pt-24 pb-8 mx-auto sm:px-6 md:pb-12 ${height}`}>
        {kicker && <p className='mb-2 kicker !text-spot'>{kicker}</p>}
        <h1 className='h1'>{title}</h1>
        {description && (
          <p className='max-w-2xl mt-3 text-lg font-medium text-white md:text-xl'>
            {description}
          </p>
        )}
        {children}
      </div>
    </header>
  )
}
